// extracted by mini-css-extract-plugin
export default {"root":"RouteLogs_root__cA8Q5"};